/*
* 操作路由的相关方法
* */
import {router} from "@/router/index";
import user from "@/stores/user";
import {cloneDeep} from "lodash";
import systems from "@/stores/system";
import {getTree} from "@/common/tree";
import {toRaw} from "vue";
import config from "@/config";


/*
* 获取某个路由项的下面的子路由
* getRoutes之后的路由路径是完整路由
* children子路由是定义时的路径
* 所以需要转换
*
* 同时会递归，将所有子路由的path拼接成完整的路径
* 主要用于生成菜单，如果定义了NotMenu元属性或者是动态路由  该路由将被忽略
*
* 顶部菜单栏通过这个方法获取下级菜单
* 最终返回的 子路由数组
*
* */

const used = {current: []};

export function getChildren(path) {

    /*
    * path是一个完整的路由路径
    * */
    const routes = router.getRoutes();//得到的一个可以随意修改的不影响router 的数组
    const users = user();  /*用户信息*/


    let children = [];//

    /*
    * 对比路由
    * 判断是否具有子路由
    * */
    for (let i of routes) {
        if (i.path === path) {
            if (!!i.children) {
                children = i.children;
            }
        }
    }


    /*
    * 拼接完整的子路由path访问路径
    * */
    children = children.filter((i) => {

        /* 默认配置 */
        if (!i.meta) i.meta = Object.assign({menu: true, role: 0}, i.meta);

        /*
        * 判断是否作为菜单
        * 判断是否是动态路由
        * 判断权限是否够
        * */
        return !((i.meta.menu === false) || (i.path.indexOf(":") >= 0) || (users.role < i.meta.role));

    }).map((i) => {

        /*
        * 获取路由的完整路径
        * */
        //如果本身就是绝对路径
        if (!i.path.startsWith('/')) {
            //如果是相对路径
            if (path === '/') {
                i.path = path + i.path;
            } else {
                i.path = path + '/' + i.path;
            }
        }

        /*
        *
        * 根据完整路径递归子路由
        * */
        if (!!i.children) {
            i.children = getChildren(i.path);
        }

        return i;
    })


    return children;
}


/*
* @author 友人a丶
* @date 2022-07-11
* name代表组件名
* 获取需要缓存的组件
* */
export function getChached(path = '') {

    let routes = router.getRoutes();

    let cahced = []; //是否开启缓存
    /*
    * 为空代表获取所有一级组件
    * */
    if (path === "") {
        routes.forEach((item) => {
            if (item.meta.cache) {
                cahced.push(item.meta.cache);
            }
        });
    } else {
        /*遍历目标子组件*/
        for (let i of routes) {
            if (i.path === path) {
                i.children.forEach((item) => {
                    if (item.meta.cache) {
                        cahced.push(item.meta.cache);
                    }
                });
            }
        }
    }

    return cahced;
}


/**
 * 加载本地路由
 * */
export function loadRoutes() {

    /* 批量导入子路由 */
    const modules = import.meta.glob(['@/router/routes/index.js', '@/router/routes/*/index.js', '@/router/routes/*/*/index.js', '@/router/routes/*/*/*/index.js', '@/router/routes/*/*/*/*/index.js'], {eager: true});
    const routes = Object.create(null);//空对象；

    for (let i in modules) {
        modules[i].default.forEach(item => {
            routes[item.path] = item;
        })
    }

    return routes;

}


/**
 * 加载用户路由表
 * */
export function createRoutes() {

    /* 是否已加载 */
    if (systems().filterRoutes) return;
    systems().filterRoutes = true; //标记路由已加载

    /* 可用的所有路由 */
    const all = cloneDeep(loadRoutes());
    /* 用户数据 */
    const userInfo = user();

    /* 过滤之后可用的路由 */
    const usable = getTree(toRaw(userInfo.routes), null, 'id', (item) => {
        item.keepAlive = true;
        return item;
    });


    /* 首页 */
    let index;

    /**
     * 对路由进行过滤处理
     * */
    function filterRoutes(routes, parent = "") {

        /* 页面 */
        const new_routes = [];

        /* 遍历路由项 */
        for (let i of routes) {

            /* 合并路由 */
            if (all[i.path]) {
                i = Object.assign(i, all[i.path]);
            }

            /* 元属性 */
            i.meta = Object.assign({
                icon: i.icon,
                menu: i.menu,
                name: i.name
            }, i.meta ? i.meta : {});

            /* 命名信息 */
            i.name = i.path;


            /*如果是空或者是根路径*/
            if (parent === '/' || !parent) {
                i.path = parent + i.path;
            } else {
                i.path = parent + '/' + i.path;
            }

            /* 是否具有子路由 */
            if (!!i.children) {
                /* 过滤子路由 */
                i.children = filterRoutes(i.children, i.path);
                /* 自定重定向到下一个路由 */
                if (i.children.length > 0) {
                    /* 重定向到第一个子页面 */
                    i.redirect = i.path === '/' ? config.index : i.children[0].path;
                }
            }

            /* 首页重定向到指定的子页面（首页） */
            if (i.path === "/") {
                index = i;
            }

            /* 保存数据 */
            new_routes.push(i);
        }

        return new_routes;
    }

    /* 新增路由 */
    used.current = filterRoutes(usable);

    /* 添加用户所有可用的路由 */
    router.addRoute(index);
    return true;
}


/**
 * 清空用户路由表
 * */
export function resetRoutes() {

    /* 过滤用户路由 */
    used.current.forEach(item => {
        router.removeRoute(item.name);
    });

    return true;
}



